import { get } from 'lodash';
import React, { FC, ReactNode } from 'react';
import { RemoteUserSelector, RemoteSelectorProps } from './remote-selector';
import { PropsWithStyle, RawUserValues } from './types';

export type RawUser = {
  chnName: string;
  id: string;
};

export interface UserSelectorProps extends Omit<RemoteSelectorProps<RawUserValues>, 'onChange' | 'fetcher'> {
  onChange?: (values: RawUserValues) => void;
  onFinish?: (values: RawUserValues) => void;
  limit?: number;
  labelRender?: (user: RawUser) => ReactNode;
}

export const WOAUserSelector: FC<PropsWithStyle<UserSelectorProps>> = (props) => {
  const { onChange, onFinish, labelRender, ...resetProps } = props;
  const [values, setValues] = React.useState<RawUserValues>(props.defaultValue || []);

  const fetchOaUser = async (search: string) => {
    const res = await fetch(`https://api-public.wuji.woa.com/api/dept-rtx/search-staffs?q=${search}`);
    const resJson = await res.json();
    const userList = get(resJson, 'data', []);

    return userList.map((item: any) => ({
      value: item.id,
      label: labelRender ? labelRender(item) : item.id,
    }));
  };

  const parseValues = (users: RawUserValues) => {
    // 支持从企微批量粘贴成员
    const values = users
      .map(user => user.replace(/ *\([^)]*\) */g, '').split(';'))
      .reduce((pre, cur) => pre.concat(cur), [])
      .filter(item => !!item);
    return [...new Set(values)];
  };

  return (
    <RemoteUserSelector
      fetcher={fetchOaUser}
      onChange={(users: RawUserValues) => {
        const values = Array.isArray(users) ? parseValues(users) : users;
        setValues(values);
        onChange?.(values);
      }}
      onBlur={() => onFinish?.(values)}
      {...resetProps}
    />
  );
};
